import store from 'store2'

import post from '../../../lib/post'

export default function(o,frontendType,done){

  var ombStore = store.namespace('omb')

  post(
    'data',
    {
      type: 'refreshCdn',
      frontendType: frontendType,
      token: ombStore('token'),
    },
    function(error,result){
      if(error){
        done(error)
      } else {
        o.data = result.data
        if(done){
          done()
        }
      }
    }
  )

}



// WEBPACK FOOTER //
// ./src/client/view/admin/lib/refreshCdn.js